import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cuánto tiempo me tomará aplicarlo?',
  a: 'Menos de 15–20 minutos al día, divididos entre mañana y noche.'
}, {
  q: '¿Necesito comprar algo extra?',
  a: 'No. Todo se puede aplicar sin comprar nada. Hay recomendaciones opcionales (como luz roja para la noche), pero no son obligatorias.'
}, {
  q: '¿Y si no lo aplico perfecto?',
  a: 'No necesitas perfección. Si aplicas 2 o 3 palancas, ya notarás diferencia.'
}, {
  q: '¿Esto sustituye una consulta médica?',
  a: 'No. Esto es material educativo para hábitos y optimización, no un tratamiento médico.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-16 md:py-24 bg-[#0d0d0d]" data-id="element-76">
      <div className="max-w-3xl mx-auto px-4" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-78">
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-4" data-id="element-79">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-3 md:space-y-4" data-id="element-80">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="border border-white/10 rounded-lg overflow-hidden bg-[#151515]" data-id="element-81">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-4 md:p-6 text-left" data-id="element-82">
                <span className="text-sm md:text-lg font-medium text-white pr-4" data-id="element-83">
                  {faq.q}
                </span>
                <ChevronDown className={`text-cyan-400 shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} size={18} data-id="element-84" />
              </button>

              <AnimatePresence data-id="element-85">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-86">
                    <div className="px-4 pb-4 md:px-6 md:pb-6 pt-0 text-sm md:text-base text-gray-400 border-t border-white/5" data-id="element-87">
                      <div className="pt-4" data-id="element-88">{faq.a}</div>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}